import React from 'react';
import PropTypes from 'prop-types';
import AvatarEditor from 'react-avatar-editor';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Slider from 'material-ui/Slider';

import UploadPlaceholder from '../UploadPlaceholder';

import { infoText, sliderWrapper } from './UploadDialog.less';

const UploadDialog = ({
  visible,
  image,
  scale,
  onSaveImage,
  onClose,
  onSetEditorRef,
  onSetImageRef,
  onUploadImage,
  onSelectImage,
  onScale,
  locale,
}) => (
  <Dialog
    title={locale('profile.avatar.header')}
    open={visible}
    modal
    autoScrollBodyContent
    autoDetectWindowHeight
    actions={[
      <FlatButton label={locale('profile.avatar.cancel')} onClick={onClose} secondary />,
      <RaisedButton disabled={!image} label={locale('profile.avatar.save')} onClick={onSaveImage} primary />,
    ]}
  >
    <Grid fluid>
      <Row middle="xs" center="xs">
        <input
          id="file"
          type="file"
          ref={onSetImageRef}
          style={{ display: 'none' }}
          onChange={onUploadImage}
          accept=".jpg, .jpeg, .png"
        />
        {!image && (
          <Col xs={12}>
            <UploadPlaceholder onClick={onSelectImage} locale={locale} />
          </Col>
        )}
        {image && (
          <Col xs={12}>
            <AvatarEditor
              ref={onSetEditorRef}
              image={image}
              style={{ borderRadius: '100%', border: '1px solid #f0f0f0', cursor: '' }}
              width={180}
              color={[255, 255, 255, 0.8]}
              height={180}
              border={10}
              borderRadius={150}
              scale={scale}
            />
          </Col>
        )}
        {image && (
          <Col xs={12} md={8}>
            <p className={infoText}>{locale('profile.avatar.dialogInfo')}</p>
          </Col>
        )}
        {image && (
          <Col xs={8} md={6} className={sliderWrapper}>
            <p style={{ margin: '0' }}>{locale('profile.avatar.zoom')}</p>
            <Slider
              min={1}
              max={3}
              value={scale}
              onChange={onScale}
              style={{ marginTop: '-1.5rem' }}
              sliderStyle={{ marginBottom: '28px' }}
            />
          </Col>
        )}
      </Row>
    </Grid>
  </Dialog>
);

UploadDialog.propTypes = {
  image: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  scale: PropTypes.number,
  onSaveImage: PropTypes.func,
  onClose: PropTypes.func,
  onUploadImage: PropTypes.func,
  onSelectImage: PropTypes.func,
  onSetEditorRef: PropTypes.func,
  onSetImageRef: PropTypes.func,
  onScale: PropTypes.func,
  locale: PropTypes.func,
};

export default UploadDialog;
